import { graphql } from '~/lib/graphql'

export const PlanListPriceFragment = graphql(`
  fragment PlanListPriceItem on Plan {
    listPrice
    listPriceIsReference
    listPriceComponents {
      food
      drink
      cake
      bouquet
      present
      charge
      others
    }
  }
`)
